<template>
  <div :style="styleSettings" class="wrapper">
    <div v-if="isCount" class="count_wrapper">
      <div class="count_value">
        {{ leftCounter }}
      </div>
    </div>
    <div class="icon__background"></div>
    <img
      :src="`${getIconURL(type)}`"
      :style="styleIconImage"
      alt=""
      class="promo_panel_button"
      @click="onClick(type)" />
    <div v-show="this.title || this.title === 0" :style="styleImageCounter" class="timer__background"></div>
    <span v-show="title && !isProgressAchievementCounter" :style="textStyle" class="title_text">{{ title }}</span>
    <div v-if="isProgressAchievementCounter" class="title_text title_text_counter">
      <span>
        {{ $t('welcome_popup.achievements.left') }}
      </span>
      <span> {{ title }} FS </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import store from '@/store';
import { Utils } from '@/utils/Utils';
import { ACTION } from '@/store/ACTION';

type style = { transform: string; top?: string; bottom?: string; left?: string; right?: string };
type imageBackStyle = { top: string; height: string; width: string; left?: string; right?: string };

export default Vue.extend({
  name: 'PromoIconButton',
  props: {
    type: {
      type: String,
      required: true
    },
    styleCount: {
      type: Object,
      default: () => ({
        leftCount: 0,
        rightCount: 0,
        topCount: 0,
        scaleCount: 1
      })
    },
    isCount: {
      type: Boolean,
      default: false
    },
    leftCounter: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    title: '',
    timer: 0,
    defaultLeftPosition: 200,
    sizeWrapper: {
      height: 164,
      width: 150
    },
    count: 1,
    timeUpdate: 1000
  }),
  computed: {
    ...mapGetters([
      'getAppConfiguration',
      'getIsMobile',
      'getUiPosition',
      'isLandscape',
      'isProgressAchievementCounter',
      'getNowTournament',
      'getNowAchievement',
      'getTournamentShowingIcon',
      'getAchievementShowingIcon',
      'isMenuOpen',
      'isAchievementCounter',
      'hasFreeSpinsTournament',
      'hasAchievement',
      'getAchievementClosedTime',
      'hasTournament',
      'getTournamentClosedTime',
      'getTournamentFinishedTime',
      'getProgressData',
      'getAchievementFinishedTime',
      'getCanvasPosition',
      'hasFreeBet',
      'getFreeBetClosedTime'
    ]),
    styleSettings(): style {
      const addScale: number = this.getIsMobile ? 1.3 : 1;
      const topScale: number = this.getIsMobile ? 1.1 : 1;
      const scale = addScale * this.uiScale;

      let style: style = {
        transform: 'translate(-50%, -50%) scale(' + scale + ')'
      };

      // проверяем иконка должна быть слева или справа
      if (this.isRightPosition) {
        const right: number =
          (this.isLandscape ? this.getUiPosition.landscape.panel.right : this.getUiPosition.portrait.panel.right) +
          this.styleCount.rightCount;
        style.right =
          right * scale -
          this.sizeWrapper.width +
          (this.sizeWrapper.width * scale) / 2 +
          this.getCanvasPosition.left +
          'px';
      } else
        style.left =
          (this.sizeWrapper.width / 2 + this.left + this.styleCount.leftCount) * scale +
          this.getCanvasPosition.left +
          'px';

      // проверяем иконка должна внизу или вверху
      if (!this.isLandscape && this.getUiPosition.portrait.panel.bottom) {
        style.bottom =
          this.getUiPosition.portrait.panel.bottom * scale * this.getAppConfiguration.devicePixelRatio +
          this.getCanvasPosition.top -
          (this.sizeWrapper.height - this.sizeWrapper.height * scale) +
          'px';
      } else {
        style.top =
          ((this.isLandscape ? this.getUiPosition.landscape.panel.top : this.getUiPosition.portrait.panel.top) +
            this.styleCount.topCount) *
            topScale *
            this.uiScale +
          +this.getCanvasPosition.top +
          'px';
      }

      return style;
    },
    styleIconImage(): any {
      switch (this.type) {
        case 'achievement':
          return {};
        case 'tournament':
          return {};
        case 'freeBets':
          return {
            width: 105 + 'px'
          };
        default:
          return 0;
      }
    },
    textStyle(): any {
      const style: any = {};
      if (this.isRightPosition) {
        style.right = 50 + 'px';
      } else {
        style.left = 12 + 'px';
      }
      return style;
    },
    isRightPosition(): boolean {
      const rightPortrait: number = this.getUiPosition.portrait.panel.right;
      const rightLandscape: number = this.getUiPosition.landscape.panel.right;
      return (rightPortrait && !this.isLandscape) || (rightLandscape && this.isLandscape) || this.styleCount.rightCount;
    },
    uiScale(): number {
      return this.getAppConfiguration.scale * this.styleCount.scaleCount;
    },
    left(): number {
      switch (this.type) {
        case 'achievement':
          return this.leftAchievement;
        case 'tournament':
          return this.leftTournament;
        case 'freeBets':
          return this.leftFreeBets;
        default:
          return 0;
      }
    },
    leftFreeBets(): number {
      return this.leftDefault;
    },
    leftTournament(): number {
      return this.getNowTournament && this.getTournamentShowingIcon
        ? this.isMenuOpen
          ? -200
          : this.leftDefault
        : -200 * this.uiScale;
    },
    leftAchievement(): number {
      return this.getNowAchievement && this.getAchievementShowingIcon
        ? this.isMenuOpen
          ? -200
          : this.leftDefault
        : -200 * this.uiScale;
    },
    leftDefault(): number {
      if (!this.isLandscape) return this.getUiPosition.portrait.panel.left;
      return this.isLandscape && this.getIsMobile ? 60 : 0;
    },
    styleImageCounter(): imageBackStyle {
      const top: number = this.isProgressAchievementCounter ? 95 : 115;
      const height: number = this.isProgressAchievementCounter ? 80 : 39;
      const width: number = this.isProgressAchievementCounter ? (this.isBigAchievementCounter ? 180 : 140) : 165;
      const style: imageBackStyle = {
        top: top + 'px',
        height: height + 'px',
        width: width + 'px'
      };
      if (this.isRightPosition) style.right = 40 + 'px';
      else style.left = 0 + 'px';
      return style;
    },
    isBigAchievementCounter(): boolean {
      if (!this.isProgressAchievementCounter) return false;

      return Number(this.title) / 10000 > 1;
    },
    isProgress(): boolean {
      if (!this.hasAchievement) return false;
      return this.getCurrentStep < this.getTotalStep;
    },
    getCurrentStep(): number {
      return Number(Object.values(<{ current: number; total: number }[]>this.getProgressData)[0]?.current);
    },
    getTotalStep(): number {
      return Number(Object.values(<{ current: number; total: number }[]>this.getProgressData)[0]?.total);
    }
  },
  mounted() {
    this.startTimer();
    this.titleUpdate();
  },
  destroyed() {
    this.stopTimer();
  },
  watch: {
    isProgressAchievementCounter: function () {
      this.titleUpdate();
    },
    hasFreeBet: function () {
      this.titleUpdate();
    },
    hasTournament: function () {
      this.titleUpdate();
    },
    hasAchievement: function () {
      this.titleUpdate();
    }
  },
  methods: {
    stopTimer() {
      clearTimeout(this.timer);
    },
    startTimer(): void {
      this.timer = Number(
        setInterval(() => {
          this.titleUpdate();
        }, this.timeUpdate)
      );
    },
    titleUpdate() {
      this.title = this.getIconTitle();
    },
    getIconTitle(): string {
      switch (this.type) {
        case 'freeBets':
          if (Utils.isFinishedTime(this.hasFreeBet, this.getFreeBetClosedTime)) {
            store.dispatch('CLEAR_FREE_BET');
            return '';
          }
          return Utils.getTimeForIcon(this.hasFreeBet, this.getFreeBetClosedTime);
        case 'tournament':
          if (Utils.isFinishedTime(this.hasTournament, this.getTournamentClosedTime) && !this.hasFreeSpinsTournament) {
            store.dispatch('CLEAR_TOURNAMENT');
            return '';
          }
          //Case then finished stage
          if (Utils.isFinishedTime(this.hasTournament, this.getTournamentFinishedTime)) return '';

          //Case then start stage
          return Utils.getTimeForIcon(this.hasTournament, this.getTournamentFinishedTime);
        case 'achievement':
          if (
            (Utils.isFinishedTime(this.hasAchievement, this.getAchievementFinishedTime) && this.isProgress) ||
            Utils.isFinishedTime(this.hasAchievement, this.getAchievementClosedTime)
          ) {
            store.dispatch('CLEAR_ACHIEVEMENT');
            return '';
          }

          // Case when it is counter
          if (this.isAchievementCounter) {
            // case when progress game
            if (this.isProgress) return this.$store.getters.currentAchievementCounter;
          }

          // Case when it is not counter
          return Utils.getTimeForIcon(this.hasAchievement, this.getAchievementClosedTime);
      }
      return '';
    },
    getIconURL(type: string): string {
      switch (type) {
        case 'tournament':
          return `${__PROMO_CONFIG.STATIC_URL}/assets/img/panel/tournament_icon.png`;
        case 'freeBets':
          return `${__PROMO_CONFIG.STATIC_URL}/assets/img/progress/achievements_icon.png`;
        case 'achievement':
          return `${__PROMO_CONFIG.STATIC_URL}/assets/img/panel/achievements_icon.png`;
        default:
          return '';
      }
    },
    onClick(type: string) {
      switch (type) {
        case 'achievement':
          promoApp.eventEmitter.emit(ACTION.SHOW_WELCOME_POPUP);
          break;
        case 'tournament':
          promoApp.eventEmitter.emit(ACTION.SHOW_COMMON_POPUP);
          break;
        case 'freeBets':
          promoApp.eventEmitter.emit(ACTION.SET_TAB_WELCOME_VISIBLE, { visible: true });
          break;
      }
    }
  }
});
</script>

<style scoped>
img {
  max-width: none;
}

.wrapper {
  position: fixed;
  width: 150px;
  height: 164px;
  transition: all 0.8s ease;
}

.promo_panel_button {
  transition: all 0.15s ease;
  position: absolute;
  left: 7px;
}

.promo_panel_button:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.promo_panel_button:active {
  transform: scale(0.95);
  cursor: pointer;
}

.title_text {
  position: absolute;
  font-family: 'myriadpro-boldcond', sans-serif;
  top: 111px;
  font-size: 1.9em;
  color: rgb(255, 255, 255);
  white-space: nowrap;
}

.timer__background {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.51);
  border-radius: 20px;
}

.title_text_counter {
  line-height: 32px;
  display: flex;
  flex-direction: column;
  min-width: 224px;
  left: 5px;
  top: 100px;
}

.icon__background {
  width: 110px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.51);
  position: absolute;
  border-radius: 50px;
  top: 0;
  left: 0;
}

.count_wrapper {
  position: absolute;
  left: 70px;
  top: 60px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: red;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.count_value {
  font-family: 'myriadpro-bold', sans-serif;
  font-size: 27px;
}
</style>
